import { LogoMark } from "./Logo";

export const Stamp = ({ className = "" }) => (
  <div data-testid="collab-stamp" className={`relative ${className}`} aria-label="in collaborazione con Mak Holz - Hobelware und Pellet">
    <svg viewBox="0 0 200 200" className="w-full h-full animate-[spin_28s_linear_infinite]">
      <defs>
        <path id="stampCircle" d="M100,100 m-78,0 a78,78 0 1,1 156,0 a78,78 0 1,1 -156,0" />
      </defs>
      <circle cx="100" cy="100" r="96" fill="#E8893F" />
      <circle cx="100" cy="100" r="58" fill="none" stroke="#1A110C" strokeWidth="1" strokeDasharray="2 4" />
      <text fill="#1A110C" fontSize="11" fontWeight="700" letterSpacing="1" style={{ fontFamily: "Manrope, sans-serif", textTransform: "uppercase" }}>
        <textPath href="#stampCircle" textLength="486" lengthAdjust="spacing">In collaborazione con Mak Holz • Hobelware und Pellet •</textPath>
      </text>
    </svg>
    <div className="absolute inset-0 grid place-items-center">
      <LogoMark className="w-[30%] h-[30%]" />
    </div>
  </div>
);
